<template>
  <div>
    <van-empty description="该页面不存在或无法访问" />
  </div>
</template>

<script>
import { Empty } from 'vant';
export default {
  name: 'NotFound',
  components: {
    [Empty.name]: Empty
  },
}
</script>

<style>

</style>